import React, { useState } from "react";
import { useEffect } from "react";

// react-router-dom components
import { useLocation, NavLink, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
// import SidenavCollapse from "examples/Sidenav/SidenavCollapse";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
// import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";

import Grid from "@mui/material/Grid";

import Box from "@mui/material/Box";

import HouseRoundedIcon from "@mui/icons-material/HouseRounded";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import NotificationsIcon from "@mui/icons-material/Notifications";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { GiWallet } from "react-icons/gi";
import Singh from "../../assets/images/Singh.png";
import nftBlack from "../../assets/images/nftLogoBlack.svg";
import nftGrey from "../../assets/images/nftLogoGrey.svg";

// import { collapseItem } from "examples/Sidenav/styles/sidenavCollapse";
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
import { useMediaQuery } from "react-responsive";

import CreatePost from "layouts/createpost";
import ExploreAllDialog from "layouts/dialogModals/ExploreAllDialog";
import { getUserInfo } from "services/apiService";

import colors from "assets/theme-dark/base/colors";

import { useDispatch, useSelector } from "react-redux";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const dispatch = useDispatch();
  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);
  // console.log("Data2", userAppInfo);

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  let Navigate = useNavigate();
  const { black, singh, singhGrey } = colors;
  const [controller] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;
  const location = useLocation();
  const [userInfo, setUserInfo] = useState("");
  const collapseName = location.pathname.replace("/", "");
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const [open, setOpen] = useState(false);
  const [exploreAllDialogBoolean, setExploreAllDialogBoolean] = useState(false);
  const [createPostBoolean, setCreatePostBoolean] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  // let textColor = "white";

  // if (transparentSidenav || (whiteSidenav && !darkMode)) {
  //   textColor = "dark";
  // } else if (whiteSidenav && darkMode) {
  //   textColor = "inherit";
  // }

  // const closeSidenav = () => setMiniSidenav(dispatch, true);
  // const Item = styled(Paper)(({ theme }) => ({
  //   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  //   ...theme.typography.body2,
  //   padding: theme.spacing(1),
  //   textAlign: "center",
  //   color: theme.palette.text.secondary,
  // }));

  // useEffect(() => {
  //   // A function that sets the mini state of the sidenav.
  //   function handleMiniSidenav() {
  //     setMiniSidenav(dispatch, window.innerWidth < 1200);
  //     setTransparentSidenav(
  //       dispatch,
  //       window.innerWidth < 1200 ? false : transparentSidenav
  //     );
  //     setWhiteSidenav(
  //       dispatch,
  //       window.innerWidth < 1200 ? false : whiteSidenav
  //     );
  //   }
  //   /**
  //    The event listener that's calling the handleMiniSidenav function when resizing the window.
  //   */
  //   window.addEventListener("resize", handleMiniSidenav);
  //   // Call the handleMiniSidenav function to set the state with the initial value.
  //   handleMiniSidenav();
  //   // Remove event listener on cleanup
  //   return () => window.removeEventListener("resize", handleMiniSidenav);
  // }, [dispatch, location]);

  useEffect(() => {
    // fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    const userInfoRes = await getUserInfo(localStorage.userNameSingh);
    // console.log("profileInfoRes", userInfoRes);
    if (userInfoRes.status === 200) {
      setUserInfo(userInfoRes.data);
    }
  };

  const handleRoute = async (name) => {
    if (
      name === "profile" ||
      name === "rewards" ||
      name === "settings" ||
      name === "notifications"
    ) {
      if (!loginStatus) {
        console.log("test", name);
        dispatch(loginDialogReducer(true));
        return;
      }
    }

    if (name === "home") {
      Navigate(`/`);
    } else if (name === "nft-marketplace") {
      Navigate(`/nft-marketplace`);
    } else if (name === "campaigns") {
      Navigate(`/campaigns`);
    } else if (name === "profile") {
      Navigate(`/profile/?username=${localStorage.userNameSingh}`);
    } else if (name === "rewards") {
      Navigate(`/rewards`);
    } else if (name === "settings") {
      Navigate(`/settings`);
    } else if (name === "notifications") {
      Navigate(`/notifications`);
    }
  };

  const handlePopupOpen = () => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setCreatePostBoolean(true);
  };

  const handleClose = () => {
    setCreatePostBoolean(false);
    setExploreAllDialogBoolean(false);
  };

  const openExploreAllDialog = () => {
    setExploreAllDialogBoolean(true);
  };

  return (
    <>
      <SidenavRoot
        {...rest}
        variant={isDesktopOrLaptop ? "permanent" : "temporary"}
        ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
      >
        <MDBox pt={3} pb={1} px={4} textAlign="center">
          {/* <MDBox
            display={{ xs: "block", xl: "none" }}
            position="absolute"
            top={0}
            right={0}
            p={1.625}
            onClick={closeSidenav}
            sx={{ cursor: "pointer" }}
          >
            <MDTypography variant="h6" color="secondary">
              <Icon sx={{ fontWeight: "bold" }}>close</Icon>
            </MDTypography>
          </MDBox> */}
          <MDBox component={NavLink} to="/" display="flex" alignItems="center">
            <MDBox
              sx={{
                textAlign: "center",
                width: "100%",
              }}
            >
              <img style={{ width: "70px" }} src={Singh} alt="Logo" />
              {/* <img
                style={{
                  objectFit: "cover",
                  marginLeft: "-24px",
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                }}
                src={userAppInfo?.profilePic}
                alt="Logo"
              /> */}
            </MDBox>
          </MDBox>
        </MDBox>
        <Divider
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) ||
            (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
        <MDBox sx={{ display: "flex", p: "1" }}>
          {/* <Toolbar /> */}
          {/* <Divider /> */}
          <Grid container spacing={2} sx={{ marginLeft: "0px" }}>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/" ? `${singh.main}` : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("home")}
              >
                <HouseRoundedIcon
                  sx={{
                    color:
                      location.pathname === "/"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Home
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor: createPostBoolean
                    ? `${singh.main}`
                    : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handlePopupOpen()}
              >
                <AddCircleIcon
                  sx={{
                    color: createPostBoolean
                      ? `${black.main}`
                      : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color: createPostBoolean
                      ? `${black.main}`
                      : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Create
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/nft-marketplace"
                      ? `${singh.main}`
                      : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("nft-marketplace")}
              >
                {/* <TravelExploreIcon
                  sx={{
                    color:
                      location.pathname === "/nft-marketplace"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                /> */}
                <img
                  src={
                    location.pathname === "/nft-marketplace"
                      ? nftBlack
                      : nftGrey
                  }
                  height="40px"
                  width="40px"
                />

                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/nft-marketplace"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Marketplace
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  // display: "flex",
                  // flexDirection: "column",
                  // alignItems: "center",
                  // justifyContent: "center",
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/campaigns"
                      ? `${singh.main}`
                      : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("campaigns")}
              >
                <RocketLaunchIcon
                  sx={{
                    color:
                      location.pathname === "/campaigns"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/campaigns"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Campaign
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/rewards"
                      ? `${singh.main}`
                      : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("rewards")}
              >
                <GiWallet
                  style={{
                    color:
                      location.pathname === "/rewards"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/rewards"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Rewards
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/notifications"
                      ? `${singh.main}`
                      : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("notifications")}
              >
                <NotificationsIcon
                  sx={{
                    color:
                      location.pathname === "/notifications"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/notifications"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Notifications
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/profile/"
                      ? `${singh.main}`
                      : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("profile")}
              >
                <AccountCircleIcon
                  sx={{
                    color:
                      location.pathname === "/profile/"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/profile/"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Profile
                </MDTypography>
              </MDBox>

              {/* <MDButton
                onClick={() => handleRoute("profile")}
                color={location.pathname === "/profile/" ? "singh" : "black"}
                // color="black"
                fullWidth
                sx={{
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
              >
                Profile
              </MDButton> */}
            </Grid>
            <Grid item xs={6}>
              <MDBox
                sx={{
                  height: "100px",
                  paddingTop: 3,
                  // p: 3,
                  backgroundColor:
                    location.pathname === "/settings"
                      ? `${singh.main}`
                      : "#08080C",
                  textAlign: "center",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: `${singh.main}`,
                  },
                }}
                onClick={() => handleRoute("settings")}
              >
                <SettingsIcon
                  sx={{
                    color:
                      location.pathname === "/settings"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    height: "2em",
                    width: "2em",
                  }}
                />
                <MDTypography
                  sx={{
                    color:
                      location.pathname === "/settings"
                        ? `${black.main}`
                        : `${singhGrey.main}`,
                    lineHeight: "0.950",
                    fontSize: "15px",
                    fontWeight: "bold",
                  }}
                >
                  Settings
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
          <Divider />
          <Box
            // component="main"
            sx={{ flexGrow: 1, bgcolor: "transparent", p: 1 }}
          ></Box>
        </MDBox>

        {/* <Grid item xs={12} md={6} sx={{ marginLeft: "20px" }}>
          <Typography sx={{ mt: 4, mb: 2, color: "#fff" }} variant="h4">
            Following
          </Typography>
          <List sx={{ color: "#fff" }}>
            <ListItem>
              <ListItemAvatar>
                <Avatar></Avatar>
              </ListItemAvatar>
              <ListItemText primary="Single-line" />
            </ListItem>
          </List>
        </Grid>

        <Grid sx={{ padding: 1 }}>
          <MDButton
            fullWidth
            // variant="gradient"
            color="singh"
            // sx={{
            //   backgroundColor: "#08080b",
            //   color: "#fff",
            //   borderColor: "#fff",
            //   border: "1",
            //   "&:hover": {
            //     backgroundColor: "#FF9607",
            //   },
            // }}
            onClick={() => openExploreAllDialog()}
          >
            Explore All
          </MDButton>
        </Grid> */}
      </SidenavRoot>

      {createPostBoolean && (
        <CreatePost
          openStatus={createPostBoolean}
          onClose={() => handleClose()}
        />
      )}

      {exploreAllDialogBoolean && (
        <ExploreAllDialog
          openStatus={exploreAllDialogBoolean}
          onClose={() => handleClose()}
        />
      )}
    </>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
